import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SportsAnimalRacingMeetingsWidget" */ './SportsAnimalRacingMeetingsWidget'
    ),
  modules: ['./SportsAnimalRacingMeetingsWidget'],
  loading: () => <div />
});

export default LoadableWidget;
